import React from 'react';
import NumberFormat from 'react-number-format';

const NumberInput = (props) => {
  const { input, className, suffix, ...rest } = props;
  let _input;

  function checkInputPoint(event) {
    if (event.keyCode === 190 || event.keyCode === 110) {
      _input.value = _input.value.concat(',');
    }
  }

  return (
    <NumberFormat 
      getInputRef={ (element) => _input = element }
      placeholder={ props.placeholder }
      decimalSeparator={','}
      onKeyDown={ checkInputPoint }
      suffix={ suffix }
      className={ className }
      { ...input }
      { ...rest }
    />
  )
}

export default NumberInput;


// WEBPACK FOOTER //
// ./src/components/NumberInput/NumberInput.js